import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../banner-list/model/banner-list.constants";
import { editBanner } from "./banner-edit.component.service";
import { getBannerInputs } from "../model/banner.modal";
import BannerEditTemplateComponent from "./banner-edit-template.component";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  BANNER_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const BannerEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let bannerPayload = {};
    for (let i = 0; i < values.length; i++) {
      bannerPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const bannerResponse = await editBanner(
      location?.state?.row?.id,
      bannerPayload
    );

    // INFO : check api response and show relevant alert message
    if (bannerResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: bannerResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getBannerInputs({
      name: location?.state?.row?.name || "",
      sort_order: location?.state?.row?.sort_order || "",
      image: location?.state?.row?.image || "",
      url: location?.state?.row?.url || "",
      status: location?.state?.row?.status || "",
      repeater: location?.state?.row?.repeater || "",
    }),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <BannerEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default BannerEditComponent;
